(() => {
  const STORAGE_KEY = "line_floating_bubble_dismissed";

  function initLineFloating(root) {
    const bubble = root.querySelector("[data-line-floating-bubble]");
    const closeButton = root.querySelector("[data-line-floating-close]");
    if (!bubble || !closeButton) return;

    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      bubble.classList.add("is-hidden");
    }

    closeButton.addEventListener("click", () => {
      bubble.classList.add("is-hidden");
      sessionStorage.setItem(STORAGE_KEY, "1");
    });
  }

  function boot() {
    document.querySelectorAll("[data-line-floating]").forEach(initLineFloating);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
